'use strict';

const DialogComponent = require('./dialog');

/** Initialization of global dialogs */

const dialogs = {
    elements: {
        $body: $(document.body)
    },

    selectors: {
        openDialogButton: '[data-open-dialog]'
    },

    init() {
        this.initEvents();
    },

    initEvents() {
        this.elements.$body.on('click', this.selectors.openDialogButton, this.handleClickOpenDialogButton.bind(this));
    },

    handleClickOpenDialogButton(e) {
        e.preventDefault();

        const $button = $(e.currentTarget);
        const dialogId = $button.data('open-dialog');

        if (!dialogId) {
            return;
        }

        const initialSlideNumberFromButton = $button.data('image-index');

        const dialogComponent = new DialogComponent(
            document.getElementById(dialogId),
            {
                initialSlideNumber: initialSlideNumberFromButton
            }
        );

        dialogComponent.handleClickOpenDialogButton();
    }
};

module.exports = dialogs;
